import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';

import type { FooterItem } from './types';

type FooterNavProps = {
  menu: FooterItem[];
};

const linkClassName =
  'm-[5px] inline-block cursor-pointer rounded-[15px] border border-[#4d4d4f] bg-[#696969] px-3 py-1.5 text-[13px] leading-[17px] text-[#fffff0] no-underline lg:m-0 lg:block lg:border-0 lg:bg-transparent lg:px-0 lg:py-[5px] lg:text-[14px] lg:text-white';

const FooterNav = ({ menu }: FooterNavProps) => {
  const fireFooterLink = useNavigationLinkInteraction('footer');

  return (
    <div
      className="mx-5 my-[25px] flex flex-wrap justify-center lg:m-0 lg:block lg:grow-[2]"
      role="navigation"
    >
      {menu.map(({ link, name, external }, index) => {
        const onClick = () => fireFooterLink(link, index + 1, { label: name });

        if (external) {
          return (
            <a
              href={link}
              className={linkClassName}
              key={name}
              onClick={onClick}
              rel="noopener noreferrer"
              target="_blank"
            >
              {name}
            </a>
          );
        }

        return (
          <a href={link} className={linkClassName} key={name} onClick={onClick}>
            {name}
          </a>
        );
      })}
    </div>
  );
};

export default FooterNav;
